import * as serviceWorker from './serviceWorker'
import { initializeRouting } from './navigation'
import './styles/index.scss'

initializeRouting()
serviceWorker.unregister()
